<div class="cart-box" (click)="isShow =!isShow" [routerLink]="['/cart']">
  <app-common-svg-icon [icon]="'stroke-ecommerce'"></app-common-svg-icon>
  @if(cart && cart.products && cart.products.length>0){
  <span class="badge rounded-pill badge-danger">{{cart.products.length}} </span>
  }
</div>
<div class="cart-dropdown onhover-show-div" [class.active]="isShow">
  <h5 class="f-18 f-w-600 mb-0 dropdown-title">Cart</h5>
  <ul>
    @if(cart && cart.products){
    @for (product of cart.products; track product) {
    <li>
      <div class="d-flex">
        <!-- <img class="img-fluid b-r-5 me-3 img-60" src="assets/images/other-images/cart-img.jpg" alt=""> -->
        <div class="flex-grow-1">
          <span class="f-w-600">{{product.productName}}</span>
          <div class="qty-box">
            <div class="input-group">
              <span class="input-group-prepend">
                <button class="btn quantity-left-minus" type="button" data-type="minus" data-field=""
                  (click)="decrement(product)">-</button>
              </span>
              <input class="form-control input-number" type="text" name="quantity" [value]="product.quantity">
              <span class="input-group-prepend">
                <button class="btn quantity-right-plus" type="button" data-type="plus" data-field=""
                  (click)="increment(product)">+</button>
              </span>
            </div>
          </div>
          <h6 class="font-primary">{{formatAmount(product.total)}}</h6>
        </div>
        <div class="close-circle">
          <a class="bg-danger" (click)="remove(product)">
            <app-feather-icons [icons]="'x'"></app-feather-icons>
          </a>
        </div>
      </div>
    </li>
    }
    <li class="total">
      <h6 class="mb-0">Order Total : <span class="f-w-600 f-right">{{formatAmount(cart.total)}}</span></h6>
    </li>
    }
    <li class="text-center"><a class="d-block mb-3 view-cart f-w-700" [routerLink]="['/cart']">Go to your cart</a>
      <a class="btn btn-primary view-checkout" (click)="checkout()">Checkout</a>
    </li>
  </ul>
</div>